<template>
  <v-dialog v-model="dialog" width="600">
    <template v-slot:activator="{}">
      <BaseButton
        v-if="showBtnType == 'group' || showBtnType == 'role'"
        @click="showBtnType == 'role' ? openModalAddRole() : openModalAddGroup()"
        :text="
          showBtnType == 'role'
            ? localStorage.translations.pages['setting-structure_company'].buttons.create_role
            : localStorage.translations.pages['setting-structure_company'].buttons.create_group
        "
        default_icon="button-add"
      >
        <template v-slot:icon>
          <svg
            v-if="showBtnType == 'role'"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path
                d="M10.3334 4.3335C9.98587 4.3335 9.7038 4.03483 9.7038 3.66683V2.66683H7.18528V3.66683C7.18528 4.03483 6.90321 4.3335 6.55565 4.3335C6.2081 4.3335 5.92603 4.03483 5.92603 3.66683V2.66683C5.92603 1.9315 6.4908 1.3335 7.18528 1.3335H9.7038C10.3983 1.3335 10.9631 1.9315 10.9631 2.66683V3.66683C10.9631 4.03483 10.681 4.3335 10.3334 4.3335Z"
                fill="#F2F2F2"
              />
              <path
                d="M8.89151 10.2532C8.77817 10.2999 8.61447 10.3332 8.44447 10.3332C8.27447 10.3332 8.11077 10.2999 7.95966 10.2399L0.888916 7.74658V12.8332C0.888916 13.8466 1.66336 14.6666 2.6204 14.6666H14.2685C15.2256 14.6666 16 13.8466 16 12.8332V7.74658L8.89151 10.2532Z"
                fill="#F2F2F2"
              />
              <path
                d="M5.66057 11.3689L5.67178 11.6113C5.82628 11.4259 6.02814 11.3333 6.27733 11.3333C6.70471 11.3333 6.92026 11.5632 6.924 12.0231V13.2976H6.57824V12.0213C6.57699 11.8823 6.54335 11.7795 6.47731 11.7129C6.41252 11.6464 6.31097 11.6131 6.17267 11.6131C6.06053 11.6131 5.9621 11.6416 5.87737 11.6987C5.79264 11.7557 5.72661 11.8306 5.67926 11.9233V13.2976H5.3335V11.3689H5.66057Z"
                fill="#277FAF"
              />
              <path
                d="M8.28462 13.3333C8.0105 13.3333 7.78747 13.2477 7.61553 13.0766C7.44358 12.9043 7.35761 12.6743 7.35761 12.3867V12.3261C7.35761 12.1348 7.39561 11.9643 7.47161 11.8145C7.54887 11.6636 7.65602 11.546 7.79308 11.4616C7.93138 11.376 8.0809 11.3333 8.24164 11.3333C8.50454 11.3333 8.70888 11.4158 8.85466 11.581C9.00044 11.7462 9.07333 11.9827 9.07333 12.2905V12.4277H7.70337C7.70835 12.6179 7.76629 12.7718 7.87718 12.8894C7.98932 13.0059 8.13137 13.0641 8.30331 13.0641C8.42542 13.0641 8.52884 13.0403 8.61356 12.9928C8.69829 12.9453 8.77243 12.8823 8.83597 12.8038L9.04717 12.9607C8.87771 13.2091 8.62353 13.3333 8.28462 13.3333ZM8.24164 11.6042C8.10208 11.6042 7.98496 11.6529 7.89027 11.7504C7.79557 11.8466 7.73701 11.9821 7.71458 12.1568H8.72757V12.1318C8.7176 11.9643 8.67026 11.8347 8.58553 11.7432C8.5008 11.6505 8.38617 11.6042 8.24164 11.6042Z"
                fill="#277FAF"
              />
              <path
                d="M11.2657 12.8431L11.6544 11.3689H12.0002L11.4114 13.2976H11.1311L10.6395 11.8359L10.1611 13.2976H9.88073L9.29387 11.3689H9.63777L10.0359 12.8128L10.5068 11.3689H10.7853L11.2657 12.8431Z"
                fill="#277FAF"
              />
            </g>
            <path
              fill-rule="evenodd"
              clip-rule="evenodd"
              d="M2.80566 7.36973C4.26823 6.90289 5.33342 5.46551 5.33342 3.76471C5.33342 3.6188 5.32558 3.47483 5.31033 3.33325H14.2686C15.2256 3.33325 16.0001 4.15325 16.0001 5.16659V6.69325L8.59564 9.30658C8.54527 9.32658 8.4949 9.33325 8.44453 9.33325C8.39416 9.33325 8.34379 9.32658 8.29342 9.30658L2.80566 7.36973Z"
              fill="#F2F2F2"
            />
            <path
              d="M2.10911 3.39176H3.55556V4.01329H2.10911V5.64703H1.44645V4.01329H0V3.39176H1.44645V1.88232H2.10911V3.39176Z"
              fill="#F2F2F2"
            />
            <defs>
              <clipPath id="clip0">
                <rect width="15.1111" height="16" fill="white" transform="translate(0.888916)" />
              </clipPath>
            </defs>
          </svg>
          <svg
            v-else
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <g clip-path="url(#clip0)">
              <path d="M0.800049 8.80005H4.80005V12.8H0.800049V8.80005Z" fill="#F2F2F2" />
              <path d="M8.80005 8.80005H16V16H8.80005V8.80005Z" fill="#F2F2F2" />
              <path
                d="M7.76 7.52L7.2 8H8.8V6.56L8.32 6.96C8.32 6.96 7.84 6.56 7.6 6.16C7.36 5.76 7.2 5.28 7.2 4.8H9.6V0H4V4.8H6.4C6.4 5.28 6.24 5.76 6 6.16C5.76 6.56 5.28 6.96 5.28 6.96L4.8 6.56V8H6.4L5.84 7.52C5.84 7.52 6.32 7.12 6.64 6.56C6.72 6.48 6.72 6.4 6.8 6.32C6.88 6.4 6.88 6.48 6.96 6.56C7.28 7.12 7.76 7.52 7.76 7.52Z"
                fill="#F2F2F2"
              />
              <path
                d="M9.87484 11.2427L9.88426 11.5336C10.014 11.3112 10.1836 11.2 10.3929 11.2C10.7519 11.2 10.933 11.4759 10.9361 12.0278V13.5572H10.6457V12.0256C10.6446 11.8588 10.6164 11.7354 10.5609 11.6556C10.5065 11.5757 10.4212 11.5358 10.305 11.5358C10.2108 11.5358 10.1281 11.57 10.057 11.6385C9.98578 11.7069 9.93031 11.7967 9.89054 11.908V13.5572H9.6001V11.2427H9.87484Z"
                fill="#277FAF"
              />
              <path
                d="M12.079 13.6C11.8488 13.6 11.6614 13.4973 11.517 13.2919C11.3726 13.0852 11.3003 12.8092 11.3003 12.4641V12.3914C11.3003 12.1618 11.3323 11.9572 11.3961 11.7775C11.461 11.5964 11.551 11.4552 11.6661 11.354C11.7823 11.2513 11.9079 11.2 12.0429 11.2C12.2638 11.2 12.4354 11.2991 12.5579 11.4973C12.6803 11.6955 12.7416 11.9793 12.7416 12.3486V12.5133H11.5908C11.595 12.7415 11.6436 12.9262 11.7368 13.0673C11.831 13.2071 11.9503 13.277 12.0947 13.277C12.1973 13.277 12.2842 13.2484 12.3554 13.1914C12.4265 13.1344 12.4888 13.0588 12.5422 12.9647L12.7196 13.1529C12.5772 13.4509 12.3637 13.6 12.079 13.6ZM12.0429 11.5251C11.9257 11.5251 11.8273 11.5836 11.7478 11.7005C11.6682 11.816 11.619 11.9786 11.6002 12.1882H12.4511V12.1582C12.4427 11.9572 12.403 11.8017 12.3318 11.6919C12.2606 11.5807 12.1643 11.5251 12.0429 11.5251Z"
                fill="#277FAF"
              />
              <path
                d="M14.5831 13.0117L14.9097 11.2427H15.2001L14.7056 13.5572H14.4701L14.0572 11.8032L13.6553 13.5572H13.4198L12.9268 11.2427H13.2157L13.5501 12.9754L13.9457 11.2427H14.1796L14.5831 13.0117Z"
                fill="#277FAF"
              />
            </g>
            <defs>
              <clipPath id="clip0">
                <rect width="16" height="16" fill="white" />
              </clipPath>
            </defs>
          </svg>
        </template>
      </BaseButton>
    </template>
    <transition :duration="150">
      <div class="modal">
        <CloseModalBtn :closeModal="closeModal" />
        <h4 class="f30">
          {{
            data.typeMethod == 'create'
              ? data.typeItem == 'role'
                ? localStorage.translations.pages['setting-structure_company'].titles.create_role
                : localStorage.translations.pages['setting-structure_company'].titles.create_group
              : data.typeMethod == 'link'
              ? data.typeItem == 'role'
                ? localStorage.translations.pages['setting-structure_company'].titles.link_role
                : localStorage.translations.pages['setting-structure_company'].titles.link_group
              : data.typeMethod == 'edit'
              ? data.typeItem == 'role'
                ? localStorage.translations.pages['setting-structure_company'].titles.edit_role
                : localStorage.translations.pages['setting-structure_company'].titles.edit_group
              : ''
          }}
        </h4>

        <v-form
          class="form"
          ref="form"
          lazy-validation
          v-model="valid"
          @submit.prevent="onAddWorkRole"
        >
          <template v-if="data.parentId && employeeRolesGrid.length && data.typeMethod !== 'edit'">
            <label>{{
              localStorage.translations.pages['setting-structure_company']['labels']['parent_name']
            }}</label>
            <p class="f24" style="color: #135baf">
              {{ employeeRolesGrid.find((i) => i.id === data.parentId).name }}
            </p>
          </template>

          <div class="form_item" v-if="data.typeMethod == 'create' || data.typeMethod == 'edit'">
            <label>{{
              localStorage.translations.pages['setting-employee_roles']['dialogs-add_edit-labels'][
                'nazvanie'
              ]
            }}</label>
            <transition name="fade" mode="out-in">
              <v-text-field
                style="width: 100%"
                outlined
                height="48px"
                :placeholder="
                  localStorage.translations.pages['setting-employee_roles'][
                    'dialogs-add_edit-labels'
                  ]['nazvanie']
                "
                v-model="name"
                :rules="[inputRules.required, inputRules.max100]"
              />
            </transition>
          </div>
          <div
            class="form_item"
            v-if="
              data.typeItem == 'role' && (data.typeMethod == 'create' || data.typeMethod == 'edit')
            "
          >
            <label>{{
              localStorage.translations.pages['setting-structure_company']['labels'][
                'vacancies_count'
              ]
            }}</label>
            <transition name="fade" mode="out-in">
              <v-text-field
                style="width: 100%"
                outlined
                height="48px"
                :placeholder="
                  localStorage.translations.pages['setting-structure_company']['labels'][
                    'vacancies_count'
                  ]
                "
                v-model="vacancies_count"
                :rules="[inputRules.required]"
              />
            </transition>
          </div>

          <div
            class="form_item"
            v-if="data.parentId && data.typeMethod === 'link' && employeeRolesGrid.length"
          >
            <transition name="fade" mode="out-in">
              <v-skeleton-loader
                v-if="!employeeRolesGrid"
                width="100%"
                height="86px"
                type="list-item"
              />
              <v-autocomplete
                v-else
                class="selectCustom"
                prepend-inner-icon="search"
                outlined
                dense
                height="46px"
                :placeholder="
                  localStorage.translations.pages.personnel_department
                    .dialog_employeepositionappointment_inputs['ne-vybran']
                "
                v-model="select_item_id"
                :items="
                  employeeRolesGrid.filter((i) => i.id !== data.parentId && i.type == data.typeItem)
                "
                :item-value="(i) => i.id"
                :item-text="(i) => i.name"
                append-icon="fas fa-angle-down"
                menu-props="offset-y"
                :rules="[inputRules.required]"
              ></v-autocomplete>
            </transition>
          </div>

          <div class="container_btn">
            <BaseButton
              type="submit"
              :text="
                data.typeMethod === 'edit'
                  ? localStorage.translations.pages.common.buttons.sohranit
                  : localStorage.translations.pages.common.buttons.dobavit
              "
              default_icon="button-save"
            />
          </div>
        </v-form>
      </div>
    </transition>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import CloseModalBtn from 'components/CloseModalBtn'

export default {
  name: 'StructureCompanyAddAndLinkWorkRoleModal',
  components: { CloseModalBtn },
  props: { showBtnType: String },
  data() {
    return {
      valid: true,
      dialog: false,
      name: null,
      vacancies_count: 1,
      select_item_id: null,
      data: {},
    }
  },
  computed: {
    ...mapGetters(['apiDomain', 'inputRules']),
    ...mapGetters('employeeRoles', ['employeeRolesGrid']),
    selectItem() {
      return this.employeeRolesGrid.find((i) => i.id === this.select_item_id)
    },
  },
  methods: {
    ...mapActions('employeeRoles', [
      'onEmployeeRolesGrid',
      'onEmployeeRolesCreate',
      'onEmployeeRolesUpdate',
    ]),
    openModalAddRole(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'role'
      this.data.typeMethod = 'create'
    },
    openModalAddGroup(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'group'
      this.data.typeMethod = 'create'
    },
    openModalLinkRole(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'role'
      this.data.typeMethod = 'link'
    },
    openModalLinkGroup(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'group'
      this.data.typeMethod = 'link'
    },
    openModalEditRole(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'role'
      this.data.typeMethod = 'edit'
      ;(this.name = this.employeeRolesGrid.find((i) => i.id === this.data.parentId).name),
        (this.vacancies_count = this.employeeRolesGrid.find(
          (i) => i.id === this.data.parentId,
        ).vacancies_count)
    },
    openModalEditGroup(parentId) {
      this.dialog = true
      this.data.parentId = parentId
      this.data.typeItem = 'group'
      this.data.typeMethod = 'edit'
      this.name = this.employeeRolesGrid.find((i) => i.id === this.data.parentId).name
    },
    closeModal() {
      this.dialog = false
      this.select_item_id = null
      this.name = null
      this.data = {}
    },
    validate() {
      this.$refs.form.validate()
    },
    async onAddWorkRole() {
      await this.validate()
      if (this.valid === true) {
        if (this.data.typeMethod === 'create') {
          let data = {
            name: this.name,
            parent_id: this.data.parentId ? this.data.parentId : null,
            type: this.data.typeItem,
          }
          if (this.data.typeItem === 'role') {
            data.vacancies_count = this.vacancies_count
          }
          this.onEmployeeRolesCreate(data)
            .then((response) => {
              if (response) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'uspeshno-dobavlen'
                      ],
                    IsError: false,
                  },

                  { root: true },
                )
                this.onEmployeeRolesGrid({
                  limit: 100000,
                  page: 1,
                })
                this.closeModal()
              }
            })
            .catch((err) => {
              if (err.response.data && err.response.data.name && err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    //  + ' ' + err.response.data.message
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        } else {
          let data = {}
          if (this.data.typeMethod === 'link') {
            data.id = this.select_item_id
            data.parent_id = this.data.parentId
            data.type = this.employeeRolesGrid.find((i) => i.id === this.select_item_id).type
            data.name = this.employeeRolesGrid.find((i) => i.id === this.select_item_id).name
          } else if (this.data.typeMethod === 'edit') {
            data.id = this.data.parentId
            data.name = this.name
            data.type = this.employeeRolesGrid.find((i) => i.id === this.data.parentId).type
            if (this.data.typeItem === 'role') {
              data.vacancies_count = this.vacancies_count
            }
          }

          this.onEmployeeRolesUpdate(data)
            .then(() => {
              this.$store.dispatch(
                'popup/onMessage',
                {
                  message:
                    this.localStorage.translations.pages.common.notifications[
                      'izmeneniya-uspeshno-sohraneny'
                    ],
                  IsError: false,
                },

                { root: true },
              )
              this.onEmployeeRolesGrid({
                limit: 10000000,
                page: 1,
              })
              this.closeModal()
            })
            .catch((err) => {
              if (err.response.data && err.response.data.name && err.response.data.name[0]) {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message:
                      this.localStorage.translations.pages.common.notifications[
                        'name_is_already_in_use'
                      ],
                    IsError: true,
                  },
                  { root: true },
                )
              } else {
                this.$store.dispatch(
                  'popup/onMessage',
                  {
                    message: this.localStorage.translations.pages.common.notifications['oshibka'],
                    IsError: true,
                  },
                  { root: true },
                )
              }
            })
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.modal {
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0px 30px 30px rgba(39, 127, 175, 0.2);
  text-align: start;
  padding: 60px;
  position: relative;
  .close {
    padding: 16px;
  }
  .form {
    margin: 40px 0 0px;
    display: grid;
    grid-template-columns: 1fr;
    flex-direction: column;
    justify-content: flex-start;
    justify-items: flex-start;
    align-items: flex-start;
    // row-gap: 30px;
    max-width: 420px;
    &_item {
      width: 100%;
    }
    .selectCustom {
      width: 100%;
    }
    .container_btn {
      margin-top: 30px;
    }
  }
}
</style>
